import { render, staticRenderFns } from "./NewList1.vue?vue&type=template&id=aea9d87a&scoped=true&"
import script from "./NewList1.vue?vue&type=script&lang=js&"
export * from "./NewList1.vue?vue&type=script&lang=js&"
import style0 from "./NewList1.vue?vue&type=style&index=0&id=aea9d87a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea9d87a",
  null
  
)

export default component.exports